import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { DayPilotScheduler } from "daypilot-pro-react";
import { Modal } from '@daypilot/modal';

import './servicecalendar.css';
import { Search } from "./Search";
import { ServiceCalendarTitle } from './ServiceCalendarTitle';
import { ServiceCalendarPopupAddEvent } from './popups/ServiceCalendarPopupAddEvent';

import { getNumberDays, convertDateType, convertDateTime } from './utils/ServiceCalendarUtils';
import { ServiceCalendarPopupShowColors } from './popups/ServiceCalendarPopupShowColors';
import { ServiceCalendarPopupShowVehicle } from './popups/ServiceCalendarPopupShowVehicle';
import { ServiceCalendarPopupShowEvent } from './popups/ServiceCalendarPopupShowEvent';
import { ServiceCalendarPopupFilter } from './popups/ServiceCalendarPopupFilter';

import get from "../../lib/request";


const colorsData = [
    { name: "Safety Inspection", value: "rgba(246, 178, 107, 1)", valueBorder: "rgba(245, 154, 35, 1)" },
    { name: "Annual Prep", value: "rgba(111, 168, 220, 1)", valueBorder: "rgba(60, 141, 188, 1)" },
    { name: "Oil", value: "rgba(142, 124, 195, 1)", valueBorder: "rgba(132, 0, 255, 1)" },
    { name: "Tacho2", value: "rgba(147, 196, 125, 1)", valueBorder: "rgba(60, 141, 188, 1)" }
];

// const resourcesData = [
//     { name: "SC22UOJ", id: "SC22UOJ", make: "Ford", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "YS21JTZ", id: "YS21JTZ", make: "Murat", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "SC22UOK", id: "SC22UOK", make: "Torben", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "SN15DCX", id: "SN15DCX", make: "Ford", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "YO68SDX", id: "YO68SDX", make: "Murat", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "BV17CKL", id: "BV17CKL", make: "Murat", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "PT64PAN", id: "PT64PAN", make: "Ford", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "NL17YCK", id: "NL17YCK", make: "Torben", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "AB12XYZ", id: "AB12XYZ", make: "Ford", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "CD34LMN", id: "CD34LMN", make: "Murat", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "EF56OPQ", id: "EF56OPQ", make: "Torben", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "GH78RST", id: "GH78RST", make: "Murat", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "JK90UVW", id: "JK90UVW", make: "Ford", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "MN11DEF", id: "MN11DEF", make: "Torben", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "PQ22GHI", id: "PQ22GHI", make: "Torben", model: 'Transit', nextServiceDate: '20-03-2025' },
//     { name: "RS33JKL", id: "RS33JKL", make: "Murat", model: 'Transit', nextServiceDate: '20-03-2025' }
// ];

// const eventsData = [
//     {
//         id: 1,
//         colosDataId: 0,
//         text: "",
//         start: "2025-02-27T00:00:00",
//         end: "2025-02-28T00:00:00",
//         backColor: "rgba(246, 178, 107, 1)",
//         resource: "SC22UOJ"
//     },
//     {
//         id: 2,
//         colosDataId: 1,
//         text: "",
//         start: "2025-03-03T00:00:00",
//         end: "2025-03-04T00:00:00",
//         backColor: "rgba(111, 168, 220, 1)",
//         resource: "PT64PAN"
//     },
//     {
//         id: 3,
//         colosDataId: 2,
//         text: "",
//         start: "2025-03-10T00:00:00",
//         end: "2025-03-11T00:00:00",
//         backColor: "rgba(142, 124, 195, 1)",
//         resource: "BV17CKL"
//     },
//     {
//         id: 4,
//         colosDataId: 3,
//         text: "",
//         start: "2025-03-18T00:00:00",
//         end: "2025-03-19T00:00:00",
//         backColor: "rgba(147, 196, 125, 1)",
//         resource: "JK90UVW"
//     },
//     {
//         id: 5,
//         colosDataId: 1,
//         text: "",
//         start: "2025-03-02T00:00:00",
//         end: "2025-03-03T00:00:00",
//         backColor: "rgba(111, 168, 220, 1)",
//         resource: "EF56OPQ"
//     },
//     {
//         id: 6,
//         colosDataId: 3,
//         text: "",
//         start: "2025-03-23T00:00:00",
//         end: "2025-03-24T00:00:00",
//         backColor: "rgba(147, 196, 125, 1)",
//         resource: "MN11DEF"
//     },
//     {
//         id: 7,
//         colosDataId: 2,
//         text: "",
//         start: "2025-03-17T00:00:00",
//         end: "2025-03-18T00:00:00",
//         backColor: "rgba(142, 124, 195, 1)",
//         resource: "EF56OPQ"
//     },
//     {
//         id: 8,
//         colosDataId: 0,
//         text: "",
//         start: "2025-03-11T00:00:00",
//         end: "2025-03-12T00:00:00",
//         backColor: "rgba(246, 178, 107, 1)",
//         resource: "MN11DEF"
//     }
// ];

const ServiceCalendar = () => {
    // const [loading, setLoading] = useState(true);

    const selfRef = useRef(null);
    const searchRef = useRef(null);
    const newEventPopupRef = useRef(null);
    const showColorsPopupRef = useRef(null);
    const showVehiclePopupRef = useRef(null);
    const showEventPopupRef = useRef(null);
    const showFilterPopupRef = useRef(null);

    const [scheduler, setScheduler] = useState(null);
    const [resources, setResources] = useState([]);
    const [events, setEvents] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [intervalMonths, setIntervalMonths] = useState(2);

    // Add Event Popup
    const [newEventPopupDate, setNewEventPopupDate] = useState("");
    const [newEventPopupVehicle, setNewEventPopupVehicle] = useState("");
    const [newEventPopupDisplayStyle, setNewEventPopupDisplayStyle] = useState("none");
    const [newEventPopupLeft, setNewEventPopupLeft] = useState('');
    const [newEventPopupTop, setNewEventPopupTop] = useState('');

    // Show Colors Popup
    const [showColorsPopupDisplayStyle, setShowColorsPopupDisplayStyle] = useState(false);
    const [showColorsPopupLeft, setShowColorsPopupLeft] = useState('');
    const [showColorsPopupTop, setShowColorsPopupTop] = useState('');

    // Show Vehicle Popup
    const [showVehiclePopupDisplayStyle, setShowVehiclePopupDisplayStyle] = useState("none");
    const [showVehiclePopupNextServiceDate, setShowVehiclePopupNextServiceDate] = useState("");
    const [showVehiclePopupVehicle, setShowVehiclePopupVehicle] = useState("");
    const [showVehiclePopupModel, setShowModelPopupModel] = useState("");
    const [showVehiclePopupMake, setShowVehiclePopupMake] = useState("");
    const [showVehiclePopupLeft, setShowVehiclePopupLeft] = useState('');
    const [showVehiclePopupTop, setShowVehiclePopupTop] = useState('');

    // Show Event Popup
    const [showEventPopupDisplayStyle, setShowEventPopupDisplayStyle] = useState("none");
    const [showEventPopupDate, setShowEventPopupDate] = useState("");
    const [showEventPopupVehicle, setShowEventPopupVehicle] = useState("");
    const [showEventPopupTime, setShowEventPopupTime] = useState("");
    const [showEventPopupColor, setShowEventPopupColor] = useState(colorsData[0]);
    const [showEventPopupLeft, setShowEventPopupLeft] = useState('');
    const [showEventPopupTop, setShowEventPopupTop] = useState('');

    // Show Filter Popup
    const [showFilterPopupDisplayStyle, setShowFilterPopupDisplayStyle] = useState(false);
    const [showFilterPopupLeft, setShowFilterPopupLeft] = useState('');
    const [showFilterPopupTop, setShowFilterPopupTop] = useState('');

    const handleSelectMonths = (months) => {
        setIntervalMonths(months);
    }

    const handleSelectedStartDate = (date) => {
        setStartDate(date);
    }

    const handleShowColorsPopup = (show, x, y) => {
        setShowColorsPopupDisplayStyle(show);
        setShowColorsPopupLeft(x + 'px');
        setShowColorsPopupTop(y + 'px');
    }

    const handleShowFilterPopup = (show, x, y) => {
        setShowFilterPopupDisplayStyle(show);
        setShowFilterPopupLeft(x + 'px');
        setShowFilterPopupTop(y + 'px');
    }

    const handleRefreshDate = () => {
        setStartDate(new Date());
        setIntervalMonths(2);
    }

    const handleClickOutside = (event) => {
        if (showColorsPopupRef.current && !showColorsPopupRef.current.contains(event.target)) {
            setShowColorsPopupDisplayStyle(false);
        }
        if (showFilterPopupRef.current && !showFilterPopupRef.current.contains(event.target)) {
            setShowFilterPopupDisplayStyle(false);
        }
        if (showVehiclePopupRef.current && !showVehiclePopupRef.current.contains(event.target) && !event.target.closest(".scheduler_default_rowheader_scroll")) {
            setShowVehiclePopupDisplayStyle('none');
        }
        if (newEventPopupRef.current && !newEventPopupRef.current.contains(event.target)) {
            setNewEventPopupDisplayStyle('none');
        }
        if (showEventPopupRef.current && !showEventPopupRef.current.contains(event.target)) {
            setShowEventPopupDisplayStyle('none');
        }
    }
    // const [eventsData, setEventsData] = useState([]);



    const getEventUpdate = async () => {
        try {
            const res = await get("https://api.ecoachvms.com/makeTestData?type=eventsData&amount=75", true);
            if (res?.data) {
                const uniqueVehicles = [
                    ...new Map(res.data.map(event => [event.vehicle_id, { id: `Vehicle ${event.vehicle_id}`, name: `Vehicle ${event.vehicle_id}` }])).values()
                ];
                const uniqueEventData = [
                    ...new Map(res.data.map(event => [event.id, { id: event.id, colosDataId: event.vehicle_id, backColor: `${event.backColor}`, start: `${event.start}`, end: `${event.end}`, resource: `Vehicle ${event.vehicle_id}`, serviceType: `Vehicle ${event.service_type}` }])).values()
                ];

                setResources(uniqueVehicles);
                setEvents(uniqueEventData);
            }
        } catch (error) {
            console.error("Error fetching Events:", error);
        }
    };

    useEffect(() => {
        getEventUpdate();
    }, []); // Runs once when the component mounts



    const [config, setConfig] = useState({
        cellWidthSpec: "Fixed",
        cellWidth: 20,
        eventHeight: 24,
        durationBarVisible: false,
        timeHeaders: [
            { groupBy: "Month" },
            { groupBy: "Day", format: "d" }
        ],
        scale: "Day",
        cornerHtml: "<span>Vehicle</span>",
        cornerText: 'Vehicle',
        startDate: startDate,
        timeRangeSelectedHandling: "Enabled",
        eventMarginTop: 2,
        eventMarginBottom: 1,
        onTimeRangeSelected: async (args) => {
            const dp = args.control;

            // dp.clearSelection();
            //   if (modal.canceled){
            //     return;
            //   }

            const currentCell = dp.getCoords();
            const viewPort = dp.getViewPort();
            const x = viewPort.topLeft.x;
            const y = viewPort.topLeft.y;
            const topLeftCell = dp.cells.findXy(x, y);
            const rect = selfRef.current.getBoundingClientRect();
            const timeHeaderHeight = 60;

            const eventStartDate = convertDateType(args.start);
            setNewEventPopupDate(eventStartDate);
            setNewEventPopupVehicle(args.resource);
            setNewEventPopupDisplayStyle('block');
            setNewEventPopupLeft(currentCell.x + rect.x + dp.rowHeaderWidth + "px");
            setNewEventPopupTop(currentCell.y + rect.y + timeHeaderHeight + "px");

            // const form = [
            //     {
            //         name: 'Date',
            //         id: 'date',
            //         type: 'text',
            //         value: eventStartDate,
            //     },
            //     {
            //         name: 'Vehicle',
            //         id: 'vehicle',
            //         type: 'text',

            //     },
            // ];
            // const data = {};

            // Modal.form(form, data).then(modal => {
            //     console.log(modal.result);
            // });

            // setNewEventPopupLeft(args.originalEvent.pageX + "px");
            // setNewEventPopupTop(args.originalEvent.pageY + "px");
            //   dp.events.add({
            //     start: args.start,
            //     end: args.end,
            //     id: DayPilot.guid(),
            //     resource: args.resource,
            //     text: 'My new event'
            //     // text: modal.result,
            //   });
        },
        onBeforeEventRender: (args) => {
            if (!searchRef.current?.phrase) {
                return;
            }
            //   args.data.html = replaceAll(
            //     args.data.text,
            //     searchRef.current.phrase,
            //     "<span style='background-color: #ffa500; color: #fff;'>$&</span>"
            //   );
        },
        onRowClick: async (args) => {
            const selectedRow = args.row.data;
            setShowVehiclePopupVehicle(selectedRow.name);
            setShowVehiclePopupMake(selectedRow.make);
            setShowModelPopupModel(selectedRow.model);
            setShowVehiclePopupNextServiceDate(selectedRow.nextServiceDate);
            setShowVehiclePopupLeft(args.originalEvent.pageX + "px");
            setShowVehiclePopupTop(args.originalEvent.pageY + "px");
            setShowVehiclePopupDisplayStyle('block');
        },
        onEventClick: (args) => {
            args.preventDefault();
            const event = args.e.data;
            const eventStartDate = convertDateType(event.start);
            const eventStartDateTime = convertDateTime(event.start);
            const eventTitle = { name: event.serviceType, value: event.backColor, valueBorder: event.backColor };
            const eventServiceVehicle = event.resource;


            setShowEventPopupDate(eventStartDate);
            setShowEventPopupTime(eventStartDateTime);
            setShowEventPopupVehicle(eventServiceVehicle);
            setShowEventPopupColor(eventTitle);
            setShowEventPopupLeft(args.originalEvent.pageX + "px");
            setShowEventPopupTop(args.originalEvent.pageY + "px");
            setShowEventPopupDisplayStyle('block');

            setShowColorsPopupDisplayStyle(false);
            setShowFilterPopupDisplayStyle(false);
            setShowVehiclePopupDisplayStyle('none');
            setNewEventPopupDisplayStyle('none');

            // popup.innerHTML = `<strong>${event.text}</strong><br>${event.start} - ${event.end}<br>${event.description}`;
        },
        treeEnabled: false,
    });

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    // const loadData = (args) => {
    //     // setResources(resourcesData);
    //     // setEvents(eventsData);        
    // }

    useEffect(() => {
        // if (scheduler) {
        //     loadData();
        //     scheduler.cornerText = "Vehicle";
        // }
    }, [scheduler]);

    const replaceAll = (source, search, replace) => {
        const esc = search.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        const reg = new RegExp(esc, "ig");
        return source.replace(reg, replace);
    };

    return (
        <>
            <div className='div-service-calendar'>
                <ServiceCalendarTitle
                    onRefreshDate={handleRefreshDate}
                />
                {scheduler &&
                    <Search
                        startDate={startDate}
                        intervalMonths={intervalMonths}
                        scheduler={scheduler}
                        onSelectMonths={handleSelectMonths}
                        onSelectStartDate={handleSelectedStartDate}
                        onShowColorsPopup={handleShowColorsPopup}
                        onShowFilterPopup={handleShowFilterPopup}
                        ref={searchRef}
                    />
                }
                <div ref={selfRef}>
                    <DayPilotScheduler
                        {...config}
                        resources={resources}
                        events={events}
                        startDate={startDate}
                        days={getNumberDays(startDate, intervalMonths)}
                        controlRef={setScheduler}
                    />
                </div>
                <div ref={newEventPopupRef}>
                    <ServiceCalendarPopupAddEvent
                        displayStyle={newEventPopupDisplayStyle}
                        date={newEventPopupDate}
                        vehicle={newEventPopupVehicle}
                        left={newEventPopupLeft}
                        top={newEventPopupTop}
                    />
                </div>
                <div ref={showColorsPopupRef}>
                    <ServiceCalendarPopupShowColors
                        colors={colorsData}
                        displayStyle={showColorsPopupDisplayStyle ? "block" : "none"}
                        left={showColorsPopupLeft}
                        top={showColorsPopupTop}
                    />
                </div>
                <div ref={showVehiclePopupRef}>
                    <ServiceCalendarPopupShowVehicle
                        displayStyle={showVehiclePopupDisplayStyle}
                        nextServiceDate={showVehiclePopupNextServiceDate}
                        vehicle={showVehiclePopupVehicle}
                        make={showVehiclePopupMake}
                        model={showVehiclePopupModel}
                        left={showVehiclePopupLeft}
                        top={showVehiclePopupTop}
                    />
                </div>
                <div ref={showEventPopupRef}>
                    <ServiceCalendarPopupShowEvent
                        displayStyle={showEventPopupDisplayStyle}
                        nextServiceDate={showEventPopupDate}
                        vehicle={showEventPopupVehicle}
                        time={showEventPopupTime}
                        date={showEventPopupDate}
                        color={showEventPopupColor}
                        left={showEventPopupLeft}
                        top={showEventPopupTop}
                    />
                </div>
                <div ref={showFilterPopupRef}>
                    <ServiceCalendarPopupFilter
                        displayStyle={showFilterPopupDisplayStyle ? "block" : "none"}
                        left={showFilterPopupLeft}
                        top={showFilterPopupTop}
                    />
                </div>
            </div>
        </>
    );
};

export default ServiceCalendar;

